<template>
    <div>
        <!-- <el-button type="text" @click="importData" class="import_btn">导入</el-button> -->
        <el-dialog title="导入" :close-on-click-modal="false"  :visible.sync="show" class="dialog_import" :before-close="cancle">
            <el-form>
            <el-form-item label="模版下载：" >
                <div class="_loading">
                    <a :href="fileModuleUrl" target="_blank">
                        <el-button type="search">模板下载</el-button>
                    </a>
                    <p><span class="el-icon-warning"></span>请严格按照模板格式填写！</p>
                </div>
            </el-form-item>
            <el-form-item label="模板导入：" >
                <el-input v-model="filename"></el-input>
                <div class="uploadEXcel">
                <input type="file" id="input" accept=".xls,.xlsx " :multiple="false" @change="changeFile" />
                <el-button slot="trigger" type="search">模板导入</el-button>
                </div>
            </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
            <el-button type="search" @click="submitForm">确定</el-button>
            <el-button @click="cancle">取消</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { Imports } from '@/api/manageConfig'
import { setUrlApi } from '@/utils/index.js'

export default {
  props: {
    show: Boolean,
    closeDialog:Function,
    searchList:Function,
    idList: Array
  },
  data() {
    return {
      file: '',
      filename: '',
      actionUrl: '/api/api/instructions/import',
      fileModuleUrl: '/template/导入模板-默认显示配置.xlsx'
    }
  },
  created(){
    this.fileModuleUrl = setUrlApi() + '/template/导入模板-默认显示配置.xlsx'
  },
  methods: {
    changeFile(event){
      var fileList = event.target.files[0]; // (利用console.log输出看file文件对象)
      if(fileList) {
        this.filename = fileList.name
        this.file = fileList
      } else {
        this.$message.error('文件上传失败')  
      }
      document.getElementById("input").value='';

    },
    cancle() {
      this.$emit('closeDialog')
      this.filename = ''
      this.file = ''
    },
    submitForm(){
      if(this.file){
        let params = new FormData()
        params.append('file', this.file)
        // console.log(params);
        Imports(params).then(res=>{
          let data =res.data
          if(data.state == 1){
            this.$message.success('导入成功')   
            this.$emit('searchList')
            this.cancle()
          } else if(data.state == 0) {
            this.$message.error(data.message)   
          }
        })
      }else{
        this.$message({
          type: 'warning',
          message: '请上传文件后再导入！'
        }); 
      }
    },
  }
}
</script>

<style lang="scss" >
.dialog_del{
  .el-radio{
    color: #666666;
    margin-top: 19px;
  }
  .el-radio__inner{
    width: 16px;
    height: 16px;
  }
}
// 弹框
.el-dialog__wrapper{
  display: flex;
  align-items: center;
  justify-content: center;

  >.el-dialog{
    border-radius: 16px;
    margin: 0 !important;
    .el-select{
      width: 100%;
    }
  
    .el-dialog__header{
      border-bottom: 1px solid #EBEAEA;
      height: 54px;
      color: #3135D7;
      font-size: 14px;
      padding: 16px 24px;
      .el-dialog__title{
        font-size: 14px;
        color: #3135D7;
      }
      .el-dialog__headerbtn{
        color: #CCCCCC;
        &:hover{
          color: #3135D7;
          .el-dialog__close{
            color: #3135D7;
          }
        }
      }
    }
    .el-dialog__footer{
      text-align: center;
      border-top: 1px solid #EBEAEA;
      height: 64px;
      line-height: 64px;
      padding: 0;
      .el-button--default{
        margin-left: 32px;
        border-radius: 4px;
      }
    }
    .el-dialog__body{
      padding: 24px;
      height: calc(100% - 120px);
      .el-form{
        // padding-right: 75px;
        .el-form-item__label::before{
          display: none;
        }
      }
      ._loading{
          display: flex;
          p{
              margin-left: 8px;
              color: #999999;
          }
      }
    }
    .el-button--search{
        background-color: #3135D7;
        color: #fff;
        border-radius: 4px;
    }
  }

  
}
  .el-dialog__wrapper.dialog_import{
    .el-dialog__body{
        height: calc(100% - 120px);
    }
    
    .el-dialog{
        height: 22.9%;
        width: 23.78%!important;
        min-width: 410px;
        min-height: 256px;
        margin-top: 0 !important;
      .el-form-item__label{
        width: 86px;
      }
      .el-form-item__content{
        width: calc(100% - 86px);
        display: inline-block;
        word-break: break-word;
      }
     .el-input{
       width: calc(100% - 112px);
       margin-right: 16px;
     }
     .uploadEXcel{
      width: 86px;
      display: inline-block;
      position: relative;
      input{
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        opacity: 0;
      }
     }
    }
  }

</style>